module.exports = __webpack_public_path__ + "FondoTituloNosotros.49fc072de11036bf47fe.png";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/Nosotros/FondoTituloNosotros.png
// module id = ../../../../../src/assets/Nosotros/FondoTituloNosotros.png
// module chunks = styles